module.exports = __webpack_public_path__ + "static/logo@1x-b7ff1031f5bd7d56cec7a5ed9d8c33cf.png";